var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 60,
    viewBox: "0 0 57.43 86.768",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M652.341,964.86a28.774,28.774,0,0,0-28.711,28.711c-.183,17.355,8.813,30.165,18.352,43.612,3.179,4.36,6.359,8.995,9.356,13.9a1.047,1.047,0,0,0,1,.544,1.256,1.256,0,0,0,1-.544c3-4.817,6.269-9.449,9.449-13.992,9.449-13.447,18.626-26.167,18.264-43.429a28.787,28.787,0,0,0-28.706-28.8Z",
    transform: "translate(-623.627 -964.86)",
    fill: "#bc88fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.2d9f97b5a2102296938411c5fdf229f4.svg";
export { ForwardRef as ReactComponent };